"use client"

import * as React from "react"
import { Button } from "../../../components/ui/button"
import { motion, useAnimation } from "framer-motion"
import { useAuthModal } from "../../../components/auth/use-auth-modal"
import { useInView } from "react-intersection-observer"
import VideoEmbed from "../../../components/marketing/landing/VideoEmbed"

export function ShowcaseVideo() {
  const { showRegister } = useAuthModal()
  const controls = useAnimation()
  const [showcaseVideoRef, showcaseVideoInView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  React.useEffect(() => {
    if (showcaseVideoInView) {
      controls.start({ opacity: 1, scale: 1 })
    } else {
      controls.start({ opacity: 0, scale: 0.8 })
    }
  }, [showcaseVideoInView, controls])

  return (
    <div className="bg-white py-24">
      <div className="container grid md:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col items-center md:items-start text-center md:text-left gap-4">
          <h2 className="text-[24px] md:text-[36px] lg:text-[42px] text-black font-bold">
            Streamline + Simplify
          </h2>
          <p className="text-sm md:text-base lg:text-lg">
            Created by coaches and entrepreneurs, Zoee is coaching software that
            streamlines and simplifies the details of running your business, so
            you can focus on what matters most - your clients.
          </p>
          <Button
            onClick={() => showRegister({ accountType: "coach" })}
            size="lg"
          >
            Start Your Free Trial
          </Button>
        </div>

        <motion.div
          ref={showcaseVideoRef}
          className="w-full border-4 lg:border-8 border-black rounded-xl overflow-hidden relative"
          animate={controls}
        >
          <VideoEmbed />
        </motion.div>
      </div>
    </div>
  )
}
